import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../../../components/styled-components/loader/loader";
import { Link } from "react-router-dom";

import law from "../../../../assets/images/latest/law.png";
import Distributions from "../../../../assets/images/latest/Distributions.png";
import stock from "../../../../assets/images/stock.png";

import Trust from "../../../../assets/images/latest/Trust.png";
import Insurance from "../../../../assets/images/latest/Insurance.png";
import Networth2 from "../../../../assets/images/latest/Networth2.png";
import Vacation from "../../../../assets/images/latest/Vacation-Home.png";
import "./styles/IncomeSelect.css";

const IncomeAllocation = () => {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();

  const [annuitydata, setAnnuityData] = useState([]);
  const [healthdata, setHealthData] = useState([]);
  const [casualtydata, setCasualtyData] = useState([]);
  const [insurancedata, setDataInsurance] = useState([]);

  // new states for income
  const [legaldata, setLegalData] = useState([]);
  const [contractdata, setContractData] = useState([]);
  const [paymentdata, setPaymentData] = useState([]);
  const [stockdata, setStockData] = useState([]);

  async function getAllIncomeAssets() {
    setIsLoading(true);
    let data = await MODULE_API.insuraceAllocation("Income");
    if (data && data.data) {
      console.log("data inside insuarce", data.data);
      data.data.map((item) => {
        if (item.name === "Non-Investment Income") {
          item.type.map((item) => {
            if (item.name === "Legal") {
              setLegalData(item.child);
            }
            if (item.name === "Contract") {
              setContractData(item.child);
            }
            if (item.name === "Payment") {
              setPaymentData(item.child);
            }
          });
        }
        if (item.name === "Investment Income") {
          item.type.map((item) => {
            if (item.name === "Stock") {
              setStockData(item.child);
            }
          });
        }
      });
    }
    setIsLoading(false);
  }

  function handleIncomeSelect(name) {
    history.push(`/income_new/attributes/${name}`);
  }
  useEffect(() => {
    getAllIncomeAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2 className="text-center font-weight-bold mb-4" style={{fontFamily:"Poppins"}}>
              Select the Type of Income
            </h2>
          </Col>
        </Row>
       {/* <Row gutter={16} style={{ margin: "0px" }}>
          <Col span={12}>
            <h2 className="text-center font-weight-bold mb-4">
              Non-Investment Income
            </h2>
            <div style={{ display: "flex" }}>
              <Col span={8} style={{ width: "30%" }}>
                <div className="buttons-container">
                  <div className={"button-wrap-cust"}>
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2">
                        <img src={law} height="80px" width="80px" />
                      </div>
                    </div>
                  </div>
                  {legaldata.map((incomeType, index) => {
                    let className = "button-wrap width--full";
                    return (
                      <div
                        key={index}
                        className={className}
                        onClick={() => handleIncomeSelect(incomeType.name)}
                      >
                        {incomeType.name}
                      </div>
                    );
                  })}
                </div>
              </Col>

              <Col span={8} style={{ width: "30%" }}>
                <div className="buttons-container">
                  <div className={"button-wrap-cust"} style={{ width: "100%" }}>
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2">
                        <img src={Trust} height="80px" width="80px" />
                      </div>
                    </div>
                  </div>
                  {contractdata.map((incomeType, index) => {
                    let className = "button-wrap width--full";
                    return (
                      <div
                        key={index}
                        className={className}
                        onClick={() => handleIncomeSelect(incomeType.name)}
                      >
                        {incomeType.name}
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col span={8} style={{ width: "30%" }}>
                <div className="buttons-container">
                  <div className={"button-wrap-cust"}>
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2">
                        <img src={Distributions} height="80px" width="80px" />
                      </div>
                    </div>
                  </div>
                  {paymentdata.map((incomeType, index) => {
                    let className = "button-wrap width--full";
                    return (
                      <div
                        key={index}
                        className={className}
                        onClick={() => handleIncomeSelect(incomeType.name)}
                      >
                        {incomeType.name}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </div>
          </Col>
          <Col span={8}>
            <h2 className="text-center font-weight-bold mb-4">
              Investment Income
            </h2>

            <div className={"button-wrap-cust"} style={{ marginLeft: "25%" }}>
              <div style={{ flexDirection: "column" }}>
                <div className="col-12 mt-2">
                  <img src={stock} height="80px" width="80px" />
                </div>
              </div>
            </div>

            <div className="buttons-container">
              {stockdata.map((incomeType, index) => {
                let className = "button-wrap";

                return (
                  <div
                    key={index}
                    className={className}
                    onClick={() => handleIncomeSelect(incomeType.name)}
                  >
                    {incomeType.name}
                  </div>
                );
              })}
            </div>
          </Col>
            </Row>*/}
      </div>
      <div className="selelctmain">
        <h3 className="selectHeadingmain">Non-Investment Income</h3>
        <div className="submainImage" >
        <img src={Distributions} height="50px" width="50px" />
        <h3 className="selectHeadingsubmain">Payment</h3>
      </div>
      <div className="selectmainincome">
        {paymentdata &&
          paymentdata.map((item, index) => (
            <div
              key={index}
              onClick={() => handleIncomeSelect(item.name)}
              className="selectMaincards"
            >
              <div className="selectMaincardsInner">
                {" "}
                <div className="selectMainHeader">
                  <span className="selectheadingValue">{item.name}</span>
                </div>
              </div>
            </div>
          ))}
      </div>
        <div className="submainImage">
          <img src={law} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Legal</h3>
        </div>
        <div className="selectmainincome">
          {legaldata &&
            legaldata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="submainImage">
          <img src={Trust} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Contract</h3>
        </div>
        <div className="selectmainincome">
          {contractdata &&
            contractdata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
       
        <h3 className="selectHeadingmain" style={{ marginTop: "2rem" }}>
          Investment Income
        </h3>
        <div className="submainImage">
          <img src={stock} height="50px" width="50px" />
          <h3 className="selectHeadingsubmain">Stock</h3>
        </div>
        <div className="selectmainincome">
          {stockdata &&
            stockdata.map((item, index) => (
              <div
                key={index}
                onClick={() => handleIncomeSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <Loader isLoading={loading} />
    </Fragment>
  );
};

export default IncomeAllocation;
